import { useEffect } from 'react';

const useClickOutside = (ref, callback) => {
  const hadleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', hadleClick);
    return () => {
      document.removeEventListener('mousedown', hadleClick);
    };
  });
};

export default useClickOutside;
